import { render, staticRenderFns } from "./DetailingFilter.vue?vue&type=template&id=12306b23"
import script from "./DetailingFilter.vue?vue&type=script&lang=js"
export * from "./DetailingFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports